import { render, staticRenderFns } from "./general.vue?vue&type=template&id=0a1e5c89&scoped=true&"
import script from "./general.vue?vue&type=script&lang=js&"
export * from "./general.vue?vue&type=script&lang=js&"
import style0 from "./general.vue?vue&type=style&index=0&id=0a1e5c89&prod&lang=scss&scoped=true&"
import style1 from "./general.vue?vue&type=style&index=1&id=0a1e5c89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e5c89",
  null
  
)

export default component.exports